// Third party
import { NextPage } from 'next';
import { useSession } from 'next-auth/react';

// Utils
import { routes, canonicalUrlForPath } from '@routes';

// UI
import { PublicLayout } from '@layouts/public-layout';
import { GiftCardLookup } from '@pages-components/gift-card-lookup';

const GiftCardLookupPage: NextPage = () => {
  const { data: session, status: status } = useSession();

  return (
    <PublicLayout
      session={session}
      loadingSession={status === 'loading'}
      canonicalUrl={canonicalUrlForPath(routes.giftCardLookup)}
      pageTitle="Search the balance on your gift card | Savvy"
      pageDescription="Search your gift card number to find the balance on your account."
    >
      <GiftCardLookup />
    </PublicLayout>
  );
};

export default GiftCardLookupPage;
